// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"911a2c9a","195":"3245e147","272":"b7efd21d","348":"11094d2b","407":"de0db796","415":"3359acbb","453":"1b6cbde4","480":"1701921a","618":"1286ee71","817":"7aa8c675"}[chunkId] + ".chunk.js";
};